import React from 'react';
import Cookies from 'js-cookie';
import useNavigation from 'enhancers/use-navigation';
import { defaultOptions, mountRedirectionUrl } from 'enhancers/with-portal-redirection';
import application from 'services/application';
import authentication from 'services/authentication';
import location from 'services/router/location';

import { config } from './landing.settings';
import UI from './landing.ui';

const Landing: React.FunctionComponent = () => {
  const [navigation, { forceShow }, link] = useNavigation();

  const isLoggedIn = authentication.isAuthenticated();
  const isForceShow = forceShow === '1';
  const isReturningUser = Boolean(Cookies.get(config.returnUserCookie));

  if (isLoggedIn) {
    navigation.dashboard();

    return;
  }

  if (!application.LiveJasmin) {
    location.navigate(
      mountRedirectionUrl(link.landing(), {
        ...defaultOptions,
        bypass: !isLoggedIn,
      }),
      '_self',
      true
    );

    return;
  }

  if (isReturningUser && !isForceShow) {
    navigation.login();

    return;
  }

  return <UI />;
};

export default Landing;
